import { USER_LIST_REQUEST, USER_LIST_SUCCESS, USER_LIST_FAIL } from "../action-types/userList"

const initUserList = {
    loading: false,
    userList: [],
    error: false,
    errorMsg: "",
}
export default function userListReducer(state = initUserList, action) {
    switch (action.type) {
        case USER_LIST_REQUEST: {
            return { loading: true, userList: [], error: false, errorMsg: "" }
        }
        case USER_LIST_SUCCESS: {
            return { loading: false, userList: action.payload, error: false, errorMsg: "" }
        }
        case USER_LIST_FAIL: {
            return { ...state, loading: false, error: true, errorMsg: action.payload }
        }
        default:
            return state
    }
}
